import { CustomButton } from "Components/Shared/CustomButton";
import { IColumnModel } from "Models/IColumnModel";
import CommonService from "Services/CommonService";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Modal } from "reactstrap";
import Breadcrumb from "Components/Common/Breadcrumb";
import CustomDataTable from "Components/Shared/CustomDataTable";
import PromotionalContentMaster from "./PromotionalContentForm";
import { Loader } from "Components/Loader/Loader";

const PromotionalContentDashboard = () => {
    const [promotionalContentModel, setPromotionalContentModel] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditId, setIsEditId] = useState<number>(0);
    const [search, setSearch] = useState("");
    const [promotionalContent, setPromotionalContent] = useState<any>([]);
    const [loader, setLoader] = useState(false);
    const [rowPerPageValue, setRowPerPageValue] = useState(10);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    document.title = "Promotional Contents | Panda GoGoGo ";

    const columns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Id',
            accessor: 'id',
            Filter: true,
            displayInList: false,
            width: "0%"
        }, {
            Header: 'EncryptedId',
            accessor: 'encryptedId',
            Filter: true,
            displayInList: false,
            width: "0%"
        },
        {
            Header: 'Name',
            accessor: 'name',
            width: "45%",
            displayInList: true,
            Filter: true,
            sortable: true,
        },
        {
            Header: 'Type',
            accessor: 'displayArea',
            width: "20%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'Description',
            accessor: 'description',
            width: "35%",
            displayInList: true,
            Filter: true,
            sortable: true,
        }, {
            Header: 'Active',
            accessor: 'active',
            datatype: "boolean",
            isBadge: true,
            Filter: true,
            sortable: true,
            width: '20%',
        }
    ], []);

    const onAddMenuClick = () => {
        setPromotionalContentModel(true);
    }

    const getPromotionalContentBySearch = (pageNumber: any, searchText: string, sortorder?: any, rowPerPageVal?: any,sortcolumn?:any,) => {
        setLoader(true);
        let searchModel = {
            offsetStart: pageNumber,
            rowsPerPage: rowPerPageVal > 0 ? rowPerPageVal : rowPerPageValue,
            sortOrder: sortorder ? sortorder : "Desc",
            searchText: searchText ? searchText : "",
            sortColumn: sortcolumn ? sortcolumn : "modified",
        }
        CommonService.post("PromotionalContents", "GetPromotionalContentBySearch", searchModel).then(res => {
            if (res.status == 200) {
                setLoader(false);
                let data = res.data.responseData;
                setPromotionalContent(data)
            }
        })
    }
    const rowPerPageHandler = (val) => {
        setRowPerPageValue(val);
        getPromotionalContentBySearch(1, "", "Desc", val);
    }
    const pagination = (pageNumber: any) => {
        // let getPageNumber = ((pageNumber) * 10);
        getPromotionalContentBySearch(pageNumber, search,selectedColumn);
    }
    const searchHandler = (searchKeyword: any) => {
        setSearch(searchKeyword);
        getPromotionalContentBySearch(1, searchKeyword);
    }
    const editHandler = (val: any) => {
        setIsEdit(true);
        setIsEditId(val.encryptedId);
        setPromotionalContentModel(true);
    }
    const onColumnSortChange = (columnName, sortorder) => {
        setSortOrder(sortorder);
        getPromotionalContentBySearch(1, search, sortOrder);
    };
    // const pagination = (pageNumber: any) => {
    //     getUniversityBySearch(pageNumber, search, selectedColumn, sortOrder);
    // }

    // const onColumnSortChange = (columnName, sortorder) => {
    //     setSelectedColumn(columnName);
    //     setSortOrder(sortorder);
    //     getUniversityBySearch(1, search, columnName, sortOrder);
    // };

    // const searchHandler = (searchKeyword: any) => {
    //     setSearch(searchKeyword);
    //     getUniversityBySearch(1, searchKeyword);
    // }

    const isCancel = () => {
        setIsEdit(false);
        setIsEditId(0);
        setPromotionalContentModel(false);
        getPromotionalContentBySearch(1, "");
    }

    useEffect(() => {
        getPromotionalContentBySearch(1, "")
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Loader open={loader} />
                <Breadcrumb title="Promotional Content" breadcrumbItem="Promotional Content" breadcrumbTitle={"Dashboard"}
                    breadcrumbTitlePath={"/dashboard"} breadcrumbItemPath={"/promotional-content"} />
                <div className="mt-0 d-grid">
                    <Col className="text-end" style={{ marginTop: "-20px", marginBottom: "10px" }}>
                        <CustomButton type="button" btnClassName="btn btn-success w-md" iconClasssName="fa fa-plus" name="Create" onClick={() => onAddMenuClick()} />
                    </Col>
                </div>
                <CustomDataTable
                    columns={columns}
                    data={promotionalContent}
                    rowPerPageValue={rowPerPageValue}
                    rowPerPageHandler={rowPerPageHandler}
                    canEdit={true}
                    perPageData={rowPerPageValue}
                    canDelete={false}
                    customPageSize={rowPerPageValue}
                    editHandler={editHandler} canShowButton={false} deleteHandler={undefined}
                    createHandler={undefined} path={""} canView={false} isPagination={true}
                    isGlobalFilter={false}
                    selectedPage={pagination}
                    searchHandler={searchHandler}
                    isAction={false} isShowingPageLength={true} onColumnSortChange={onColumnSortChange} />
            </div>
            <div className="container">
                <Modal isOpen={promotionalContentModel} size="md" centered>
                    <div role='document'>
                        <div className='modal-content'>
                            <div className='modal-body m-3'>
                                <PromotionalContentMaster
                                    isModelOpen={true}
                                    canCancel={isCancel}
                                    isEditId={isEditId}
                                    isEdit={isEdit}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </React.Fragment>
    );
}

export default PromotionalContentDashboard;